<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>Dedicated with love to my wife, Patricia</i>.</span></p>
<p class="ded1"><span><i>She walks the path of the sun</i>.</span></p>
<p class="ded1"><span><i>She sings the songs of the moon</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9ca03ab8